/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PriceResponse } from '../../models/price-response';

export interface GetEnergyPriceSeries$Params {
  location_id: string;
  source?: string;
  resolution?: string;
  from?: string;
  to?: string;
}

export function getEnergyPriceSeries(http: HttpClient, rootUrl: string, params: GetEnergyPriceSeries$Params, context?: HttpContext): Observable<StrictHttpResponse<PriceResponse>> {
  const rb = new RequestBuilder(rootUrl, getEnergyPriceSeries.PATH, 'get');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.query('source', params.source, {});
    rb.query('resolution', params.resolution, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PriceResponse>;
    })
  );
}

getEnergyPriceSeries.PATH = '/locations/{location_id}/energy-price-series';
